export default "__VITE_ASSET__DW7TZJi7__"